export default {
  app_name: "SELLER IM",
  http_protocol: "https",
  host: 'https://fahuo.isellso.net/',
  dev_host: 'http://127.0.0.1/ecerp2/public/',
  // dev_host: 'https://fahuo.isellso.net/',
  http_port: 80,
  ws_port: 9326,
  ws_url: 'wss://fahuo.isellso.net/wss2/',
  dev_ws_url: 'ws://127.0.0.1:1818',
  init: "/api/user/init",
  his_url: "/api/message/list",
  chat_users_url: "/api/user/chatUserList",
  platform: 'lazada',
  platforms: [
    {'name': 'lazada', 'logo': 'https://fahuo.isellso.net/assets/img/lazada/logo.jpg', 'component': 'LazadaChat'},
    {'name': 'shopee', 'logo': 'https://fahuo.isellso.net/assets/img/shopee/logo.jpg', 'component': 'shopeeChat'}
  ],
  countrys: [
    {'name': '全部', 'val': '', 'active': true},
    {'name': 'TH', 'val': 'TH'},
    {'name': 'PH', 'val': 'PH'},
    {'name': 'TW', 'val': 'TW'},
    {'name': 'MY', 'val': 'MY'},
    {'name': 'VN', 'val': 'VN'},
    {'name': 'SG', 'val': 'SG'},
  ],
  token_path: "/user/login",
  stores_path: "/store/getStoreList",
  store_page_path: "/store/getPageList",
  authurl_path: "/store/getAuthUrl",
  hangestore_path: "/store/hang",
  userinfo_path: "/user/getUserInfo",
  knowcate_path: "/knowledge/getCate",
  knowqa_path: "/knowledge/getQa",
  knowadd_path: "/knowledge/add",
  knowedit_path: "/knowledge/edit",
  knowdel_path: "/knowledge/del",
  knowcateadd_path: "/knowledge/addCate",
  knowcateedit_path: "/knowledge/editCate",
  knowcatedel_path: "/knowledge/delCate",
  knowaddrecord_path: "/knowledge/record",
  common_upload: "/common/upload",
  aftersale_list_path: "/aftersale/getList",
  aftersale_status_path: "/aftersale/setStatus",
  aftersale_add_path: "/Aftersale/add",
  track_user_path: "/Aftersale/setTrackUser",
  aftersale_getremark_path: "/Aftersale/getRemarks",
  aftersale_addremark_path: "/Aftersale/addRemark",
  aftersale_changestatus_path: "/Aftersale/changeStatus",
  presales_changestatus_path: "/Presales/changeStatus",
  presales_add_path: "/Presales/add",
  presales_edit_path: "/Presales/edit",
  presales_status_path: "/Presales/setStatus",
  presales_addremark_path: "/Presales/addRemark",
  presales_list_path: "/Presales/getList",
  childuser_path: "/user/getChildUser",
  buyerlist_path: "/Buyer/getList",
  sessiongroup_path: "/Buyer/getSessionGroup",
  addsessiongroup_path: "/Buyer/addSessionGroup",
  editsessiongroup_path: "/Buyer/editSessionGroup",
  delsessiongroup_path: "/Buyer/delSessionGroup",
  setgroup_path: "/Buyer/setGroup",
  buyermsgsend_path: "/Buyer/buyersMsgSend",
  groupmsgsend_path: "/Buyer/groupMsgSend",

  reviewlist_path: "/review/getList",
  reviewimport_path: "/review/import",
  setreviewstatus_path: "/review/setStatus",
  addreviewremark_path: "/review/remark",
  importtemp_path: "/review/importTemp",
  reviewedit_path: "/review/edit",
  setcommentoperater_path: "/review/setOperater",

  buyerinfo_path: "/Buyer/buyerInfo",

  getkfconfig_path: "/config/getKefuConfig",
  setkfconfig_path: "/config/setKefuConfig",
  csrlist_path: "/user/getCsrList",
  setcsrreceptable_path: "/user/setCsrReceptable",

  api: {
    'lazada': {
      authurl_path: "/lazada/store/getAuthUrl",
      sessionlist_path: "/lazada/session/getSessionList",
      moresession_path: "/lazada/session/moreSession",
      invitesession_path: "/lazada/session/inviteSession",
      transfermark_path: "/lazada/session/updateTransferMark",
      sessiondetail_path: "/lazada/session/getSessionDetail",
      readsession_path: "/lazada/session/readSession",
      messagelist_path: "/lazada/message/getMessages",
      sendmessage_path: "/lazada/message/sendMessage",
      voucherlist_path: "/lazada/voucher/getVoucherList",
      dialogue_path: "/lazada/other/getDialogue",
      products_path: "/lazada/product/getProducts",
      orderdetail_path: "/lazada/order/getOrder",
      orderquery_path: "/lazada/other/queryOrder",
      orderdetailquery_path: "/lazada/other/queryOrderDetail",
      orderlist_path: "/lazada/order/orderList",
      invoice_path: "/lazada/other/invoice",
      ordertrace_path: "/lazada/order/getTrace",
      followstatus_path: "/lazada/other/followStatus",
      lazadasendmessage_path: "/lazada/other/sendMessage",
      opensession_path: "/lazada/session/openSession",
      orderreview_path: "/lazada/other/getReviewByOrderId",
      searchsession_path: "/lazada/session/searchSession",
      transfercsr_path: "/lazada/session/transferCsr",
      buyermodel_path: "/lazada/buyer/rfmList"
    },
    'shopee': {
      authurl_path: "/shopee/store/getAuthUrl",
      sessionlist_path: "/shopee/session/getSessionList",
      moresession_path: "/shopee/session/moreSession",
      invitesession_path: "/shopee/session/inviteSession",
      transfermark_path: "/shopee/session/updateTransferMark",
      sessiondetail_path: "/shopee/session/getSessionDetail",
      readsession_path: "/shopee/session/readSession",
      messagelist_path: "/shopee/message/getMessages",
      sendmessage_path: "/shopee/message/sendMessage",
      productinfo_path: "/shopee/product/getProductInfo",
      uploadimage_path: "/shopee/message/uploadImage",
      products_path: "/shopee/product/getProducts",
      orderquery_path: "/shopee/other/queryOrder",
      orderdetail_path: "/shopee/order/getOrder",
      ordertrace_path: "/shopee/order/getTrace",
      orderlist_path: "/shopee/order/orderList",
      searchsession_path: "/shopee/session/searchSession",
      opensession_path: "/shopee/session/openSession",
      transfercsr_path: "/shopee/session/transferCsr",
      buyermodel_path: "/shopee/buyer/rfmList"
    }
  },

  register_url: "/register",
  ws_protocol: "ws",
  setPlatform: function (val) {
    this.platform = val;
  },
  getHostUrl: function() {
    return (
      process.env.NODE_ENV == 'production' ? this.host+'im.php' : this.dev_host+'im.php'
    );
  },
  getWsUrl: function() {
    return process.env.NODE_ENV == 'production' ? this.ws_url : this.dev_ws_url
  },
  getTokenUrl: function() {
    return this.getHostUrl() + this.token_path;
  },
  getStoresUrl: function() {
    return this.getHostUrl() + this.stores_path;
  },
  getStoreByUid: function() {
    return this.getHostUrl() + '/store/getStoreByUid';
  },
  getStorePageUrl: function() {
    return this.getHostUrl() + this.store_page_path;
  },
  getAftersaleList: function() {
    return this.getHostUrl() + this.aftersale_list_path;
  },
  getPresalesList: function() {
    return this.getHostUrl() + this.presales_list_path;
  },
  aftersaleAdd: function() {
    return this.getHostUrl() + this.aftersale_add_path;
  },
  salesDetail: function () {
      return this.getHostUrl() + "/aftersale/detail";
  },
  setTrackUser: function() {
    return this.getHostUrl() + this.track_user_path;
  },
  getRemarks: function() {
    return this.getHostUrl() + this.aftersale_getremark_path;
  },
  addRemark: function() {
    return this.getHostUrl() + this.aftersale_addremark_path;
  },
  changeSalesStatus: function() {
    return this.getHostUrl() + this.aftersale_changestatus_path;
  },
  changePsalesStatus: function() {
    return this.getHostUrl() + this.presales_changestatus_path;
  },
  addPresaleRemark: function() {
    return this.getHostUrl() + this.presales_addremark_path;
  },
  presalesAdd: function() {
    return this.getHostUrl() + this.presales_add_path;
  },
  presalesEdit: function() {
    return this.getHostUrl() + this.presales_edit_path;
  },
  aftersaleStatus: function() {
    return this.getHostUrl() + this.aftersale_status_path;
  },
  presalesStatus: function() {
    return this.getHostUrl() + this.presales_status_path;
  },
  getReviewList: function () {
    return this.getHostUrl() + this.reviewlist_path;
  },
  reviewImport: function () {
    return this.getHostUrl() + this.reviewimport_path;
  },
  reviewDel: function () {
    return this.getHostUrl() + '/review/del';
  },
  setReviewStatus: function () {
    return this.getHostUrl() + this.setreviewstatus_path;
  },
  addReviewRemark: function () {
    return this.getHostUrl() + this.addreviewremark_path;    
  },
  importTemp: function () {
    return this.getHostUrl() + this.importtemp_path;
  },
  reviewEdit: function () {
    return this.getHostUrl() + this.reviewedit_path;
  },
  setCommentOperater: function () {
    return this.getHostUrl() + this.setcommentoperater_path;
  },
  getUserinfoUrl: function() {
    return this.getHostUrl() + this.userinfo_path;
  },
  getChildUser: function() {
    return this.getHostUrl() + this.childuser_path;
  },
  commonUpload: function () {
    return this.getHostUrl() + this.common_upload;
  },
  hangStore: function () {
    return this.getHostUrl() + this.hangestore_path;
  },
  queryOrder: function () {
    return this.getHostUrl() + this.api[this.platform]['orderquery_path'];
  },
  getInvoice: function () {
    return this.getHostUrl() + this.api['lazada']['invoice_path'];
  },
  queryOrderDetail: function () {
    return this.getHostUrl() + this.api['lazada']['orderdetailquery_path'];
  },
  followStatus: function () {
    return this.getHostUrl() + this.api['lazada']['followstatus_path'];
  },
  openSession: function (platform) {
    platform = platform ? platform : this.platform;
    return this.getHostUrl() + this.api[platform]['opensession_path'];
  },
  getReviewByOrderId: function () {
    return this.getHostUrl() + this.api['lazada']['orderreview_path'];
  },
  getAuthUrl: function (platform) {
    return this.getHostUrl() + this.api[platform]['authurl_path'];
  },
  getSessionList: function () {
    return this.getHostUrl() + this.api[this.platform]['sessionlist_path'];    
  },
  moreSession: function () {
    return this.getHostUrl() + this.api[this.platform]['moresession_path'];    
  },
  inviteSession: function () {
    return this.getHostUrl() + this.api[this.platform]['invitesession_path'];    
  },
  updateTransferMark: function () {
    return this.getHostUrl() + this.api[this.platform]['transfermark_path'];
  },
  transferCsr: function () {
    return this.getHostUrl() + this.api[this.platform]['transfercsr_path'];    
  },
  getSessionDetail: function ($platform) {
    $platform = $platform ? $platform : this.platform;
    return this.getHostUrl() + this.api[$platform]['sessiondetail_path'];        
  },
  readSession: function () { 
    return this.getHostUrl() + this.api[this.platform]['readsession_path'];            
  },
  getMessages: function () {
    return this.getHostUrl() + this.api[this.platform]['messagelist_path'];    
  },
  sendMessage: function () {  
    return this.getHostUrl() + this.api[this.platform]['sendmessage_path'];    
  },
  lazadaSendMessage: function () {  
    return this.getHostUrl() + this.api['lazada']['lazadasendmessage_path'];    
  },
  getVoucherList: function ($platform) {
    $platform = $platform ? $platform : this.platform;
    return this.getHostUrl() + this.api[$platform]['voucherlist_path'];  
  },
  getDialogue: function () {
    return this.getHostUrl() + this.api[this.platform]['dialogue_path'];  
  },
  getProducts: function () {
    return this.getHostUrl() + this.api[this.platform]['products_path'];  
  },
  getOrder: function ($platform) {
    $platform = $platform ? $platform : this.platform;
    return this.getHostUrl() + this.api[$platform]['orderdetail_path'];  
  },
  getOrders: function () {
    return this.getHostUrl() + this.api[this.platform]['orderlist_path'];  
  },
  getTrace: function () {
    return this.getHostUrl() + this.api[this.platform]['ordertrace_path'];  
  },
  getBuyerInfo: function () {
    return this.getHostUrl() + '/'+this.platform+'/buyer/buyerInfo';
  },
  getBuyerModel: function () {
    return this.getHostUrl() + this.api[this.platform]['buyermodel_path'];  
  },
  searchSession: function () {
    return this.getHostUrl() + this.api[this.platform]['searchsession_path'];  
  },
  getProductInfo: function ($platform) {
    $platform = $platform ? $platform : this.platform;
    return this.getHostUrl() + this.api[$platform]['productinfo_path'];      
  },
  getOfferDetail: function () {
    return this.getHostUrl() + '/'+this.platform+'/offer/getOfferDetail';
  },
  getVideo: function () {
    return this.getHostUrl() + '/'+this.platform+'/media/getVideo';
  },
  setWeight: function () {
    return this.getHostUrl() + '/'+this.platform+'/product/setWeight';
  },
  uploadImage: function () {    
    return this.getHostUrl() + this.api[this.platform]['uploadimage_path'];      
  },
  unreadCount: function () {
    return this.getHostUrl() + '/'+this.platform+'/session/unreadSession';
  },
  forgetReply: function ($platform) {
    $platform = $platform ? $platform : this.platform;
    return this.getHostUrl() + '/'+$platform+'/session/forgetReply';     
  },
  updateReplyStatus: function ($platform) {
    $platform = $platform ? $platform : this.platform;
    return this.getHostUrl() + '/'+$platform+'/session/updateReplyStatus';
  },
  refund: function () {
    return this.getHostUrl() + '/'+this.platform+'/order/refund';
  },
  getKnowLang: function () {
    return this.getHostUrl() + "/knowledge/langList";
  },
  getKnowCate: function () {
    return this.getHostUrl() + this.knowcate_path;
  },
  getKnowQa: function () {
    return this.getHostUrl() + this.knowqa_path;
  },
  addKnowledge: function () {
    return this.getHostUrl() + this.knowadd_path;
  },
  editKnowledge: function () {
    return this.getHostUrl() + this.knowedit_path;
  },
  delKnowledge: function () {
    return this.getHostUrl() + this.knowdel_path;
  },
  addKnowledgeCate: function () {
    return this.getHostUrl() + this.knowcateadd_path;
  },
  knowAddrecord: function () {
    return this.getHostUrl() + this.knowaddrecord_path;    
  },
  editCate: function () {
    return this.getHostUrl() + this.knowcateedit_path;
  },
  delCate: function () {
    return this.getHostUrl() + this.knowcatedel_path;
  },
  topUpKnowledge: function () {
     return this.getHostUrl() + "/knowledge/topUp";
  },
  getBuyerList: function () {
    return this.getHostUrl() + this.buyerlist_path;
  },
  getSessionGroup: function () {
    return this.getHostUrl() + this.sessiongroup_path;
  },
  addSessionGroup: function () {
    return this.getHostUrl() + this.addsessiongroup_path;
  },
  editSessionGroup: function () {
    return this.getHostUrl() + this.editsessiongroup_path;
  },
  delSessionGroup: function () {
    return this.getHostUrl() + this.delsessiongroup_path;
  },
  setGroup: function () {
    return this.getHostUrl() + this.setgroup_path;
  },
  buyersMsgSendQueue: function () {
    return this.getHostUrl() + "/Buyer/buyersMsgSendQueue";
  },
  buyersMsgSend: function () {
    return this.getHostUrl() + this.buyermsgsend_path;
  },
  groupMsgSend: function () {
    return this.getHostUrl() + this.groupmsgsend_path;
  },
  getKefuConfig: function () {
    return this.getHostUrl() + this.getkfconfig_path;
  },
  setKefuConfig: function () {
    return this.getHostUrl() + this.setkfconfig_path;
  },
  getCsrList: function () {
    return this.getHostUrl() + this.csrlist_path;
  },
  setCsrReceptable: function () {
    return this.getHostUrl() + this.setcsrreceptable_path;
  },
  translantText: function () {
    return this.getHostUrl() + '/common/translate';
  },
  wsInitialize: function () {
    let host = process.env.NODE_ENV == 'production' ? this.host : this.dev_host;
    return host+'_index.php/push/common/initialize';
  },


  getInitUrl: function() {
    return this.getHostUrl() + this.init;
  },
  getChatUsersUrl: function() {
    return this.getHostUrl() + this.chat_users_url;
  },
  getHisUrl: function() {
    return this.getHostUrl() + this.his_url;
  },
  getRegisterUrl: function() {
    return this.getHostUrl() + this.register_url;
  },
  updateStoreStatus: function() {
    return this.getHostUrl() + "/store/updateStatus";
  }
};
